var mainMenuNavigationApp = angular.module("mainMenuNavigation", ["core", "ui.bootstrap"]);

angular.module("mainMenuNavigation").directive("mainMenuLink", ["viewsLocation", "Inflector", function (viewsLocation, Inflector) {

    return {
        restrict: "E",
        replace: true,
        templateUrl: viewsLocation + "/MainMenuLink.html",
        scope: {
            item: "=",
            button: "="
        }
    };
}]);

angular.module("mainMenuNavigation").directive("mainMenuNavigation", ["viewsLocation", "Inflector", "$timeout", function (viewsLocation, Inflector, $timeout) {

    var LAYOUT_DEFAULT = "dropdown_nested";
    var LAYOUT_MEGAMENU = "megamenu_nested";
    var LAYOUT_THUMBNAILS = "megamenu_thumbnails";
    var LAYOUT_DROPMEGA = "dropdown_megamenu";
    var MEGAMENU_NUM_COLUMNS = 4;
    var NOT_COLLAPSED_ATTR = "in";

    function getChunkedItems($scope) {
        var items = angular.copy($scope.items);

        for (var i = 0; i < items.length; i++) {
            if (items[i].items) {
                if ($scope.layoutId === LAYOUT_DROPMEGA) {
                    for (var m = 0; m < items[i].items.length; m++) {
                        if (items[i].items[m].items) {
                            items[i].items[m].items = chunkSubItems(items[i].items[m].items, $scope.megaMenuNumCols);
                        }
                    }
                } else {
                    items[i].items = chunkSubItems(items[i].items, $scope.megaMenuNumCols);
                }
            }
        }

        return items;
    }

    function chunkSubItems(arr, numCols) {
        function getChunkSize(arr, numCols, i) {
            return Math.max(Math.ceil(arr.length / (numCols - i)), 1);
        }

        var newArr = [];
        var slice = [];
        var i = 0;

        while (arr.length) {
            chunkSize = getChunkSize(arr, numCols, i);
            slice = angular.copy(arr.slice(0, chunkSize));
            arr = arr.slice(slice.length, arr.length);
            i++;

            newArr.push(slice);
        }

        return newArr;
    }

    function attachEventListeners(elements) {
        $timeout(function () {
            var $container = $(elements);

            $container.on("mouseenter", ".dropdown-submenu", function () {
                var $handle = $(this);
                var $target = $("> ul.dropdown-menu", $handle);
                $target.removeAttr("style"); // clean previous status

                if (!_.isUndefined($target.offset()) && $target.offset().left + $target.width() > $(window).width()) {
                    $target.css({
                        left: -$target.width(),
                        width: $target.width(), // hack to avoid visual glitch
                        right: "auto",
                        top: 0
                    });
                }
                else {
                    $target.removeAttr("style");
                }
            });
        });
    }

    function isMegaMenu(scope) {
        switch (scope.layoutId) {
            case LAYOUT_MEGAMENU:
            case LAYOUT_THUMBNAILS:
            case LAYOUT_DROPMEGA:
                return true;
            case LAYOUT_DEFAULT:
        }

        return false;
    }

    function getMenuSource(scope) {
        if (scope.layoutId === LAYOUT_DROPMEGA) {
            return "MegaDropNavigation.html";
        } else if (isMegaMenu(scope)) {
            return "MegaMenuNavigation.html";
        } else {
            return "DropdownNavigation.html";
        }
    }

    return {
        restrict: "E",
        replace: true,
        templateUrl: viewsLocation + "/MainMenuNavigation.html",
        scope: {},
        link: function (scope, elements, attrs, ctrl) {
            var data = angular.fromJson(attrs.menuData);
            var randomCssId = Math.round((Math.pow(10, 10) * Math.random())).toString(16);

            scope.viewsLocation = viewsLocation;
            scope.items = data.items || [];
            scope.layoutId = data.layoutId || LAYOUT_DEFAULT;
            scope.name = data.name || "Menu";
            scope.cssId = Inflector.dasherise(data.name || randomCssId);
            scope.megaMenuNumCols = data.megaMenuNumCols || MEGAMENU_NUM_COLUMNS;
            scope.megaMenuColSize = Math.floor(12 / scope.megaMenuNumCols);
            scope.navClass = isMegaMenu(scope) ? "yamm" : "";
            scope.includeMenuSrc = viewsLocation + "/" + getMenuSource(scope);

            if (isMegaMenu(scope)) {
                scope.chunkedItems = getChunkedItems(scope);
            }

            scope.showThumbnails = function () {
                return scope.layoutId === "megamenu_thumbnails";
            };

            scope.toggleSubmenu = function ($event, item) {
                $event.stopPropagation();
                item.open = item.open ? false : true;
            };

            scope.setSubsectionContent = function(content) {
                scope.subsectionContent = content;
            };

            scope.hasGrandChildren = function(items) {
                var children = _.some(items, function(value, key) {
                    return value.items;
                });
                scope.menuClass = children ? "dropdown yamm-fw btn-group" : "btn-group";

                return children;
            };

            scope.collapseResponsiveMenu = attrs.responsivenessEnabled && !attrs.collapseResponsiveMenu ? NOT_COLLAPSED_ATTR : "";

            attachEventListeners(elements);
        }
    };
}]);
